var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVr(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 43,
    height: 35,
    viewBox: "0 0 43 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.372,0H25.628A3.372,3.372,0,0,1,29,3.372v16.86A3.372,3.372,0,0,1,25.628,23.6H3.372A3.372,3.372,0,0,1,0,20.233V3.372A3.372,3.372,0,0,1,3.372,0Z",
    transform: "translate(240 619.698)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-233 -614)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5,0H38a5,5,0,0,1,5,5V30a5,5,0,0,1-5,5H5a5,5,0,0,1-5-5V5A5,5,0,0,1,5,0Z",
    transform: "translate(233 614)",
    fill: "#42a5f5"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(240 622.46)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.87,7.159a1.881,1.881,0,1,0,1.88,1.881,1.883,1.883,0,0,0-1.88-1.881Zm0,0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.13,7.159A1.881,1.881,0,1,0,10.01,9.04,1.883,1.883,0,0,0,8.13,7.159Zm0,0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.42,0H3.58A3.581,3.581,0,0,0,0,3.58V14.5a3.58,3.58,0,0,0,3.58,3.58H8.817a3.57,3.57,0,0,0,2.535-1.049l1.821-1.821a1.876,1.876,0,0,1,2.657,0l1.82,1.82a3.568,3.568,0,0,0,2.533,1.047H25.42A3.581,3.581,0,0,0,29,14.5V3.58A3.58,3.58,0,0,0,25.42,0ZM8.13,12.62a3.58,3.58,0,1,1,3.58-3.58A3.584,3.584,0,0,1,8.13,12.62Zm12.741,0a3.58,3.58,0,1,1,3.58-3.58A3.584,3.584,0,0,1,20.87,12.62Zm0,0",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVr);
export default __webpack_public_path__ + "static/media/VR.08d789743b9092ef67e8cbac7780ca68.svg";
export { ForwardRef as ReactComponent };